package com.evoapps.evoshift.ui.finance

import com.evoapps.evoshift.widgets.IconButtonWithTooltip
import com.evoapps.evoshift.widgets.CollapsingHeaderLayout
import evoshift.composeapp.generated.resources.close
import evoshift.composeapp.generated.resources.chart_full_size_title
import evoshift.composeapp.generated.resources.chart_show_full_size
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.widgets.DialogWidth
import com.evoapps.evoshift.widgets.EvoDialog
import androidx.compose.material.icons.filled.OpenInFull
import com.evoapps.evoshift.domain.explain.Side
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Lock
import androidx.compose.material.icons.filled.PointOfSale
import androidx.compose.material.icons.filled.TableChart
import androidx.compose.material.icons.filled.BarChart
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.Alignment
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.domain.model.DailyRecord
import com.evoapps.evoshift.domain.model.LabourShare
import com.evoapps.evoshift.domain.model.LabourBase
import com.evoapps.evoshift.domain.model.DayResults
import com.evoapps.evoshift.domain.explain.DayExplanations
import evoshift.composeapp.generated.resources.daily_records_margin_note
import com.evoapps.evoshift.domain.model.spmhActual
import com.evoapps.evoshift.domain.model.spmhPlan
import evoshift.composeapp.generated.resources.daily_records_labor_plan
import evoshift.composeapp.generated.resources.daily_records_labor_real
import com.evoapps.evoshift.domain.model.Shift
import com.evoapps.evoshift.domain.staffing.DayStaffingHint
import com.evoapps.evoshift.domain.usecase.finance.DayTrend
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.LightGold
import com.evoapps.evoshift.ui.adaptive.DetailPane
import com.evoapps.evoshift.ui.adaptive.DetailPaneBack
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.PanePlaceholder
import com.evoapps.evoshift.ui.adaptive.PaneTags
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.user.RevenueLaborChartCard
import com.evoapps.evoshift.ui.util.StaffingHintLines
import com.evoapps.evoshift.ui.util.formatPercentOrDash
import com.evoapps.evoshift.ui.util.labourBase
import com.evoapps.evoshift.ui.util.labourPlanLabelRes
import com.evoapps.evoshift.ui.util.labourRealLabelRes
import com.evoapps.evoshift.widgets.EvoTextField
import com.evoapps.evoshift.widgets.GoldButton
import com.evoapps.evoshift.widgets.RegularCard
import com.evoapps.evoshift.widgets.formatEditable
import com.evoapps.evoshift.widgets.parseDecimal
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.spmh_plan
import evoshift.composeapp.generated.resources.spmh_real
import evoshift.composeapp.generated.resources.daily_records_actual_net
import evoshift.composeapp.generated.resources.daily_records_comments
import evoshift.composeapp.generated.resources.daily_records_costs_plan
import evoshift.composeapp.generated.resources.daily_records_costs_real
import evoshift.composeapp.generated.resources.daily_records_unlock
import com.evoapps.evoshift.ui.util.dayAndDate
import androidx.compose.material.icons.filled.LockOpen
import evoshift.composeapp.generated.resources.daily_records_income_plan
import evoshift.composeapp.generated.resources.daily_records_income_real
import evoshift.composeapp.generated.resources.daily_records_locked
import evoshift.composeapp.generated.resources.daily_records_planned_net
import evoshift.composeapp.generated.resources.daily_records_result_plan
import evoshift.composeapp.generated.resources.daily_records_result_real
import evoshift.composeapp.generated.resources.daily_records_rev_plan
import evoshift.composeapp.generated.resources.daily_records_rev_real
import evoshift.composeapp.generated.resources.number_invalid
import evoshift.composeapp.generated.resources.save
import evoshift.composeapp.generated.resources.wide_pick_day_record
import kotlinx.datetime.LocalDate
import org.jetbrains.compose.resources.stringResource


/*
 * SH-105: the daily records on wide windows. The month's figures as a row of cards across the
 * top; under them the chart on the left and the table on the right. Choosing a day opens it in a
 * pane instead of a dialog: in place of the chart on expanded windows, as a third column on
 * laptop-wide ones (the chart, the table, the day).
 */

/** Test tag of the row of month figures above the table. */
const val DAILY_KPIS_TAG = "daily_records_kpis"

/** Test tag of the chosen day's pane. */
const val DAILY_DAY_PANE_TAG = "daily_records_day_pane"

/** The month's totals the cards show: actuals to date against the plan. */
internal data class MonthFigures(
    val salesPlan: Double,
    val salesActual: Double,
    val costsPlan: Double,
    val costsActual: Double,
    val labourPercentPlan: Double?,
    val labourPercentActual: Double?,
    /** SH-191: the month's SPMH: all targets ÷ all planned hours; the takings ÷ the hours of the days with takings. */
    val spmhPlan: Double? = null,
    val spmhActual: Double? = null,
    val resultPlan: Double,
    val resultActual: Double
)

/** Sums [records]: the plan over the whole month, the actuals over the days with takings. */
internal fun monthFigures(records: List<DailyRecord>): MonthFigures {
    val withTakings = records.filter { it.revenue.realNetto != null }
    fun costsPlan(r: DailyRecord) = r.costs.plannedLabour + r.costs.otherCosts
    fun costsActual(r: DailyRecord) = r.costs.actualByContractType.values.sum() + r.costs.otherCosts
    return MonthFigures(
        salesPlan = records.sumOf { it.revenue.planNetto },
        salesActual = withTakings.sumOf { it.revenue.realNetto ?: 0.0 },
        costsPlan = records.sumOf(::costsPlan),
        costsActual = withTakings.sumOf(::costsActual),
        labourPercentPlan = LabourShare.percent(records.sumOf { it.laborStats.planned.totalCost }, records.sumOf { it.labourBasePlan }),
        labourPercentActual = if (withTakings.isEmpty()) null
            else LabourShare.percent(withTakings.sumOf { it.laborStats.actual.totalCost }, withTakings.sumOf { it.labourBaseReal ?: 0.0 }),
        spmhPlan = records.spmhPlan(),
        spmhActual = records.spmhActual(),
        resultPlan = records.sumOf { it.resultPlan },
        resultActual = withTakings.sumOf { it.resultReal }
    )
}

/** The chart's days from the daily records (the dashboards' chart, on this month's figures). */
internal fun List<DailyRecord>.toDayTrends(): List<DayTrend> = mapNotNull { record ->
    val date = runCatching { LocalDate.parse(record.date) }.getOrNull() ?: return@mapNotNull null
    val clocked = record.laborStats.actual.totalHours > 0.0 || record.laborStats.actual.totalCost > 0.0
    DayTrend(
        date = date,
        revenuePlan = record.revenue.planNetto,
        revenueActual = record.revenue.realNetto,
        laborPlanned = record.laborStats.planned.totalCost,
        laborActual = record.laborStats.actual.totalCost.takeIf { clocked },
        hoursPlanned = record.laborStats.planned.totalHours,
        hoursActual = record.laborStats.actual.totalHours,
        commissionPercent = record.revenue.commissionPercent,
        fixedRevenue = record.revenue.fixedRevenue
    )
}.sortedBy { it.date }

/**
 * SH-159: which side columns the wide daily results show in [width] when the table needs at least
 * [tableMin] not to scroll sideways: the table comes first. The compact chart sits beside it only
 * when the table still fits (otherwise the month's figures get a button that shows the chart full
 * size); the empty day pane of a laptop-wide window only when the table and the chart fit too.
 * On an expanded window a chosen day takes the chart's place.
 */
internal data class DailyWidePanes(val chart: Boolean, val placeholder: Boolean)

internal fun dailyWidePanes(width: Dp, tableMin: Dp, large: Boolean, daySelected: Boolean): DailyWidePanes {
    if (daySelected && !large) return DailyWidePanes(chart = false, placeholder = false)
    val dayPane = if (daySelected) DAY_PANE_WIDTH else 0.dp
    val chart = width - dayPane - COMPACT_CHART_WIDTH >= tableMin
    val chartWidth = if (chart) COMPACT_CHART_WIDTH else 0.dp
    val placeholder = large && !daySelected && width - chartWidth - DAY_PANE_WIDTH >= tableMin
    return DailyWidePanes(chart = chart, placeholder = placeholder)
}

/**
 * The month on an expanded or wider window: figures, chart, table and the chosen day ([selected],
 * by ISO date). [dayPane] draws the chosen day; [table] the month's table (it opens a day with a click).
 */
@Composable
internal fun DailyRecordsWideLayout(
    records: List<DailyRecord>,
    currency: String,
    selected: DailyRecord?,
    onClose: () -> Unit,
    table: @Composable () -> Unit,
    dayPane: @Composable (DailyRecord) -> Unit
) {
    val large = LocalWindowWidthClass.current.isLarge
    if (selected != null) DetailPaneBack(onClose = onClose)
    val trends = remember(records) { records.toDayTrends() }
    // A compact chart beside the table when the table keeps its width; the button shows it full size.
    var chartFullSize by remember { mutableStateOf(false) }
    val tableMin = rememberDailyTableMinWidth(records, currency)
    BoxWithConstraints(Modifier.fillMaxSize()) {
        val panes = dailyWidePanes(maxWidth, tableMin, large, daySelected = selected != null)
        // SH-154: the month's figures slide away while the table or chart scrolls, like the notes above.
        CollapsingHeaderLayout(header = {
            DailyRecordsKpis(
                records, currency, Modifier.padding(horizontal = 16.dp, vertical = 8.dp),
                // SH-159: no room for the chart beside the table: it is a button away.
                onShowChart = if (panes.chart) null else ({ chartFullSize = true })
            )
        }) {
            Row(Modifier.fillMaxSize()) {
                if (panes.chart) {
                    Column(
                        Modifier.width(COMPACT_CHART_WIDTH).fillMaxHeight().testTag(PaneTags.SUPPORTING)
                            .verticalScroll(rememberScrollState()).padding(start = 16.dp, end = 8.dp, top = 8.dp, bottom = 16.dp)
                    ) {
                        RevenueLaborChartCard(
                            trends, currency = currency, chartHeight = COMPACT_CHART_HEIGHT,
                            action = { ChartFullSizeButton { chartFullSize = true } }
                        )
                        if (!large) {
                            // Expanded: the day opens where the chart is; say so.
                            Spacer(Modifier.height(16.dp))
                            Text(
                                stringResource(Res.string.wide_pick_day_record),
                                style = MaterialTheme.typography.bodyMedium,
                                color = DeepNavy.copy(alpha = 0.55f)
                            )
                        }
                    }
                }
                if (selected != null && !large) {
                    Box(Modifier.weight(0.4f).fillMaxHeight().testTag(PaneTags.DETAIL)) { dayPane(selected) }
                    Box(Modifier.weight(0.6f).fillMaxHeight().testTag(PaneTags.LIST)) { table() }
                } else {
                    Box(Modifier.weight(1f).fillMaxHeight().testTag(PaneTags.LIST)) { table() }
                    // SH-128: the day floats as a card (DetailPane), no divider beside it.
                    if (selected != null) {
                        Box(Modifier.width(DAY_PANE_WIDTH).fillMaxHeight().testTag(PaneTags.DETAIL)) { dayPane(selected) }
                    } else if (panes.placeholder) {
                        Box(Modifier.width(DAY_PANE_WIDTH).fillMaxHeight().testTag(PaneTags.DETAIL)) {
                            Box(Modifier.fillMaxSize().testTag(PaneTags.PLACEHOLDER)) {
                                PanePlaceholder(stringResource(Res.string.wide_pick_day_record), Icons.Default.TableChart)
                            }
                        }
                    }
                }
            }
        }
    }
    if (chartFullSize) {
        EvoDialog(
            title = stringResource(Res.string.chart_full_size_title),
            onDismiss = { chartFullSize = false },
            width = DialogWidth.Full,
            dismiss = DialogAction(stringResource(Res.string.close), { chartFullSize = false })
        ) {
            RevenueLaborChartCard(trends, currency = currency, chartHeight = FULL_CHART_HEIGHT)
        }
    }
}

/** Shows the compact chart full size. */
@Composable
private fun ChartFullSizeButton(onClick: () -> Unit) {
    IconButtonWithTooltip(onClick = onClick, modifier = Modifier.handCursor().testTag(CHART_FULL_SIZE_TAG), tooltip = stringResource(Res.string.chart_show_full_size)) {
        Icon(Icons.Default.OpenInFull, contentDescription = stringResource(Res.string.chart_show_full_size), tint = DeepNavy)
    }
}

/** The daily results' chart beside the table, and shown full size. */
private val COMPACT_CHART_WIDTH = 340.dp
/** The chosen day's pane beside the table on laptop-wide windows. */
private val DAY_PANE_WIDTH = 380.dp
private val COMPACT_CHART_HEIGHT = 150.dp
private val FULL_CHART_HEIGHT = 420.dp
const val CHART_FULL_SIZE_TAG = "daily_chart_full_size"

/** The month's figures as cards: sales, costs, labour %, SPMH, result; the actuals to date, the plan under them. */
@OptIn(ExperimentalLayoutApi::class)
@Composable
internal fun DailyRecordsKpis(
    records: List<DailyRecord>,
    currency: String,
    modifier: Modifier = Modifier,
    /** SH-159: shows the chart full size (a button after the cards) when it has no room beside the table. */
    onShowChart: (() -> Unit)? = null
) {
    val figures = remember(records) { monthFigures(records) }
    val base = records.labourBase()
    fun money(v: Double) = formatMoney(v, currency)
    // SH-191: five cards (SPMH joined the labour %): two lines of them where one line would cut their figures.
    BoxWithConstraints(modifier.fillMaxWidth()) {
    val perLine = ((maxWidth + 12.dp) / (MinKpiCardWidth + 12.dp)).toInt().coerceIn(3, 5)
    FlowRow(
        Modifier.fillMaxWidth().testTag(DAILY_KPIS_TAG),
        horizontalArrangement = Arrangement.spacedBy(12.dp),
        verticalArrangement = Arrangement.spacedBy(12.dp),
        itemVerticalAlignment = Alignment.CenterVertically,
        maxItemsInEachRow = if (perLine < 5) perLine else 6
    ) {
        KpiCard(stringResource(Res.string.daily_records_rev_real), money(figures.salesActual), stringResource(Res.string.daily_records_rev_plan), money(figures.salesPlan), Modifier.weight(1f))
        KpiCard(stringResource(Res.string.daily_records_costs_real), money(figures.costsActual), stringResource(Res.string.daily_records_costs_plan), money(figures.costsPlan), Modifier.weight(1f))
        KpiCard(
            stringResource(labourRealLabelRes(base)), formatPercentOrDash(figures.labourPercentActual),
            stringResource(labourPlanLabelRes(base)), formatPercentOrDash(figures.labourPercentPlan), Modifier.weight(1f)
        )
        // SH-191: the month's SPMH beside its labour %.
        KpiCard(
            stringResource(Res.string.spmh_real), formatSpmhOrDash(figures.spmhActual, currency),
            stringResource(Res.string.spmh_plan), formatSpmhOrDash(figures.spmhPlan, currency), Modifier.weight(1f)
        )
        // SH-195: the month's result so far with its margin; tapping it shows the revenue and cost lines.
        // The days as their results count them: each day with takings its share of the recurring costs.
        val resultDay = LocalResultDay.current
        val days = remember(records, resultDay) { records.map(resultDay) }
        val actual = remember(days) { DayResults.actual(days) }
        val plan = remember(days) { DayResults.plan(days) }
        KpiCard(
            stringResource(Res.string.daily_records_result_real), money(actual.result),
            stringResource(Res.string.daily_records_result_plan), money(plan.result), Modifier.weight(1f),
            valueColor = if (actual.result >= 0) Color(0xFF2E7D32) else Color(0xFFD32F2F),
            note = stringResource(
                Res.string.daily_records_margin_note,
                formatPercentOrDash(actual.percent.takeIf { actual.days > 0 }),
                formatPercentOrDash(plan.percent)
            ),
            explain = { DayExplanations.resultOfDays(days, Side.ACTUAL) },
            currency = currency
        )
        if (onShowChart != null) {
            val label = stringResource(Res.string.chart_show_full_size)
            RegularCard(
                Modifier.width(64.dp).handCursor().testTag(CHART_FULL_SIZE_TAG).semantics { contentDescription = label },
                onClick = onShowChart
            ) {
                Box(Modifier.fillMaxWidth().height(48.dp), contentAlignment = Alignment.Center) {
                    Icon(Icons.Default.BarChart, contentDescription = null, tint = DeepNavy)
                }
            }
        }
    }
    }
}

/** SH-191: the narrowest a month figure's card can be with its amount and plan line whole. */
private val MinKpiCardWidth = 170.dp

@Composable
private fun KpiCard(
    label: String,
    value: String,
    planLabel: String,
    plan: String,
    modifier: Modifier,
    valueColor: Color = DeepNavy,
    /** SH-195: a line under the plan (the result's margin). */
    note: String? = null,
    /** SH-195: how the value was worked out (tap the figure). */
    explain: (() -> com.evoapps.evoshift.domain.explain.Calculation?)? = null,
    currency: String = ""
) {
    RegularCard(modifier = modifier) {
        Column(Modifier.padding(horizontal = 16.dp, vertical = 12.dp)) {
            Text(label, style = MaterialTheme.typography.labelMedium, color = DeepNavy.copy(alpha = 0.6f), maxLines = 1, overflow = TextOverflow.Ellipsis)
            // SH-159: a narrower card (the chart's button beside the figures) keeps the whole amount, smaller.
            val large = MaterialTheme.typography.titleLarge
            val small = MaterialTheme.typography.titleMedium
            var valueStyle by remember(value, large) { mutableStateOf(large) }
            Explainable(explain, currency) {
                Text(
                    value, style = valueStyle, fontWeight = FontWeight.Bold, color = valueColor, maxLines = 1, softWrap = false,
                    onTextLayout = { if (it.hasVisualOverflow && valueStyle != small) valueStyle = small }
                )
            }
            // The plan wraps to a second line rather than losing its figure.
            Text("$planLabel: $plan", style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.55f), maxLines = 2, overflow = TextOverflow.Ellipsis)
            note?.let { Text(it, style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.55f), maxLines = 2, overflow = TextOverflow.Ellipsis) }
        }
    }
}

/**
 * The chosen day in its pane (what the day's dialog holds on narrower windows): its figures, the
 * staffing hint, the takings, target and comments to enter ([onSave], [onLock]; read-only when
 * locked or [mayEdit] is false) and its shifts with copying the planned times.
 */
@Composable
internal fun DailyRecordDayPane(
    record: DailyRecord,
    currency: String,
    mayEdit: Boolean,
    onClose: () -> Unit,
    onSave: (netto: Double?, plan: Double?, comments: String?) -> Unit,
    /** SH-163: the typed figures saved and the day locked, after a confirmation. */
    onLock: (netto: Double?, plan: Double?, comments: String?) -> Unit,
    staffing: DayStaffingHint?,
    modifier: Modifier = Modifier,
    /** SH-257: the day's hours in one line, opening Godziny pracy on the day ([onOpenHours]); null: not shown. */
    hours: com.evoapps.evoshift.domain.model.WorkHoursDaySummary? = null,
    onOpenHours: (() -> Unit)? = null,
    /** SH-128: the day recalculated from the typed figures, until they are saved. */
    preview: DailyRecord? = null,
    onPreview: (netto: Double?, plan: Double?) -> Unit = { _, _ -> },
    onClearPreview: () -> Unit = {},
    /** SH-163: a locked day opened again (null: not offered). */
    onUnlock: (() -> Unit)? = null
) {
    val locked = record.isLocked || !mayEdit
    val muted = Color.White.copy(alpha = 0.7f)
    fun money(value: Double) = formatMoney(value, currency)
    // SH-128: typed figures show recalculated (in italics) until they are saved.
    val shown = preview ?: record
    val isPreview = preview != null
    val hasActuals = shown.revenue.realNetto != null
    val why = rememberDayWhy(shown)
    DetailPane(
        // SH-163: "Friday, 16 October", not the ISO date.
        title = dayAndDate(LocalDate.parse(record.date)),
        subtitle = if (record.isLocked) stringResource(Res.string.daily_records_locked) else null,
        icon = if (record.isLocked) Icons.Default.Lock else Icons.Default.PointOfSale,
        onClose = onClose,
        tag = DAILY_DAY_PANE_TAG,
        modifier = modifier.fillMaxSize()
    ) {
        if (staffing != null) StaffingHintLines(staffing, currency, color = muted, onDark = true)
        CardFigures(
            stringResource(Res.string.daily_records_income_plan) to money(shown.incomePlan),
            stringResource(Res.string.daily_records_income_real) to (if (hasActuals) money(shown.incomeReal) else "-"),
            firstWhy = why.income(Side.PLAN), secondWhy = why.income(Side.ACTUAL), currency = currency,
            labelColor = muted, highlightColor = LightGold, preview = isPreview
        )
        CardFigures(
            stringResource(labourPlanLabelRes(shown.labourBase)) to formatPercentOrDash(shown.labourPercentPlan),
            stringResource(labourRealLabelRes(shown.labourBase)) to (if (hasActuals) formatPercentOrDash(shown.labourPercentReal) else "-"),
            firstWhy = why.labourPercent(Side.PLAN), secondWhy = why.labourPercent(Side.ACTUAL), currency = currency,
            highlightSecond = hasActuals, labelColor = muted, highlightColor = LightGold, preview = isPreview
        )
        if (shown.labourBase == LabourBase.INCOME) {
            CardFigures(
                stringResource(Res.string.daily_records_labor_plan) to formatPercentOrDash(shown.labourPercentOfSalesPlan),
                stringResource(Res.string.daily_records_labor_real) to (if (hasActuals) formatPercentOrDash(shown.labourPercentOfSalesReal) else "-"),
                firstWhy = why.labourPercentOfSales(Side.PLAN), secondWhy = why.labourPercentOfSales(Side.ACTUAL), currency = currency,
                labelColor = muted, highlightColor = LightGold, preview = isPreview
            )
        }
        // SH-191: SPMH next to the labour %.
        DaySpmhFigures(shown, currency, labelColor = muted, highlightColor = LightGold, highlightSecond = true, preview = isPreview)
        // SH-195: the day's result and margin.
        DayResultFigures(shown, currency, labelColor = muted, highlightColor = LightGold, onDark = true, preview = isPreview)
        if (isPreview) PreviewNote(muted)

        // Keyed by the day and its saved figures: another day (or a save coming back) starts afresh.
        var planStr by remember(record.date, record.revenue.planNetto) { mutableStateOf(formatEditable(record.revenue.planNetto)) }
        var nettoStr by remember(record.date, record.revenue.realNetto) { mutableStateOf(record.revenue.realNetto?.let { formatEditable(it) } ?: "") }
        var comments by remember(record.date, record.revenue.comments) { mutableStateOf(record.revenue.comments ?: "") }
        val numberError = stringResource(Res.string.number_invalid)
        fun invalid(value: String) = value.isNotBlank() && parseDecimal(value) == null
        val valid = !invalid(planStr) && !invalid(nettoStr)
        val previewNow = rememberTypedPreview(record.date, nettoStr, planStr, enabled = !locked && valid, onClear = onClearPreview) {
            onPreview(parseDecimal(nettoStr), parseDecimal(planStr))
        }

        val save = { if (valid) onSave(parseDecimal(nettoStr), parseDecimal(planStr), comments.trim().ifBlank { null }) }
        var confirmLock by remember(record.date) { mutableStateOf(false) }
        // SH-163: the till figure first; the keyboard's Done saves.
        EvoTextField(
            value = nettoStr,
            onValueChange = { nettoStr = it },
            label = stringResource(Res.string.daily_records_actual_net),
            modifier = Modifier.previewOnBlur(previewNow),
            keyboardType = KeyboardType.Decimal,
            imeAction = ImeAction.Done,
            keyboardActions = KeyboardActions(onDone = { save() }),
            error = numberError.takeIf { invalid(nettoStr) },
            enabled = !locked,
            suffix = currency
        )
        EvoTextField(
            value = planStr,
            onValueChange = { planStr = it },
            label = stringResource(Res.string.daily_records_planned_net),
            modifier = Modifier.previewOnBlur(previewNow),
            keyboardType = KeyboardType.Decimal,
            imeAction = ImeAction.Done,
            keyboardActions = KeyboardActions(onDone = { save() }),
            error = numberError.takeIf { invalid(planStr) },
            enabled = !locked,
            suffix = currency
        )
        EvoTextField(
            value = comments,
            onValueChange = { comments = it },
            label = stringResource(Res.string.daily_records_comments),
            singleLine = false,
            minLines = 2,
            imeAction = ImeAction.Default,
            enabled = !locked
        )
        if (!locked) {
            GoldButton(
                text = stringResource(Res.string.save),
                onClick = save,
                enabled = valid,
                modifier = Modifier.fillMaxWidth().handCursor()
            )
            // SH-163: locking is a quiet action apart from Save, and asks first.
            LockDayButton(enabled = valid, onClick = { confirmLock = true }, modifier = Modifier.align(Alignment.CenterHorizontally))
        } else if (record.isLocked && mayEdit && onUnlock != null) {
            OutlinedButton(
                onClick = onUnlock,
                modifier = Modifier.fillMaxWidth().handCursor(),
                colors = ButtonDefaults.outlinedButtonColors(contentColor = Color.White),
                border = BorderStroke(1.dp, Color.White.copy(alpha = 0.4f))
            ) {
                Icon(Icons.Default.LockOpen, contentDescription = null, modifier = Modifier.size(18.dp))
                Spacer(Modifier.width(8.dp))
                Text(stringResource(Res.string.daily_records_unlock))
            }
        }
        if (confirmLock) {
            LockDayConfirmDialog(
                date = record.date,
                takings = parseDecimal(nettoStr),
                currency = currency,
                onConfirm = {
                    confirmLock = false
                    onLock(parseDecimal(nettoStr), parseDecimal(planStr), comments.trim().ifBlank { null })
                },
                onDismiss = { confirmLock = false }
            )
        }
        if (hours != null && onOpenHours != null) DayHoursLine(hours, onOpenHours)
    }
}
